<!-- <div class="row">
  <div class="col-10">
    <nav class="navbar navbar-expand-lg ">
      <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
    </nav>
  </div>
  <span class = "helplogout">
    <div class="col-2">
      <a class="getHelp">NeedHelp</a>
  </div>
  </span>
   <span class = "helplogout">
    <div class="col-2">
      <a class="logout" routerLink="/logout" routerLinkActive="active">Logout</a>
    </div>
  </span>
</div> -->

<app-header></app-header>

<div class="container-fluid px-lg-5 bg-light">
  <nav class="navbar navbar-expand-lg navbar-light">
    <!-- <a class="navbar-brand" href="#"></a> -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
            aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">

        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/registration" (click)="setFlag()">App Registration <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/app-mgmt">App Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/profile-mgmt">Profile Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/resources">Resources</a>
        </li>
      </ul>
    </div>
  </nav>
</div>
<div class="container-fluid px-lg-5">
  <br>
  <br>
  <div class="container">
    <p *ngIf="isRegistrating" class="registringmessage">Please Wait... Your App is Registerating with your Details.</p>
    <p *ngIf="isRegistrationError" class="registringmessage">{{emsg}}.</p>
  </div>

  <div *ngIf="isRegistrationComplete" class="row justify-content-center">

    <div class="col-md-8">
      <div class="card">
        <div class="card-header"><b>{{suucessfullMsg}}</b></div>
        <div class="card-body">
          <div>
            <p> <b>Application Name :</b>  {{ApplicationName}}</p>
            <p> <b>Application Purpose :</b> {{Application_Purpose}}</p>
            <p><b>Logo:</b></p><span><img class=" logo" [src]="convertImage" alt="" /><br></span>
            <p><b>Redirect URI :</b> {{redirectUrls}}</p>
            <p><b>ClientId :</b>{{responsedataClientId}}</p>
            <p><b>ClientSecret:</b>{{responsedataClientSecret}}</p>
            <p><b>Please note down the ClientSecret for your future reference. It will be not shown again.</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isRegistrationInputForm" class="container">
    <p class="mandatorynote"> Fields with * symbol are mandatory one.</p>

    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Register</div>
          <div class="card-body">
            <form class="form-horizontal" (ngSubmit)="OnRegister(f.value)" #f="ngForm">
              <!-- <div class="form-check">
                 <input
                 [(ngModel)]="checkedProduction" #prod_check="ngModel"
                 (change)="productionClicked(checkedProduction)"class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" [value]="false">
                 <label class="form-check-label" for="exampleRadios1">
                   Production
                 </label>
               </div>
               <div class="form-check">
                 <input  [(ngModel)]="checkedNonProduction" #Nonprod_check="ngModel"
                 (change)="NonproductionClicked(checkedNonProduction)"class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" [value]="true" checked />
                 <label class="form-check-label" for="exampleRadios2">
                   Non-Production
                 </label>
               </div> -->
              <br>
              <div class="form-group">
                <label for="appName" class="cols-sm-2 control-label required">Name of Application</label>
                <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"></span>
                    <input type="text" class="form-control" name="ApplicationName" placeholder="Enter Application Name"
                           [(ngModel)]="ApplicationName" required />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="appNamePurpose" class="cols-sm-2 control-label required">Application Purpose</label>
                <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"></span>
                    <input type="text" class="form-control" name="Application_Purpose" placeholder="Enter Application Purpose Details."
                           [(ngModel)]="Application_Purpose " required />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="url" class="cols-sm-2 control-label required">Redirect Url</label>
                <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"></span>
                    <input type="text" class="form-control" name="RedirectUrls" id="url" placeholder="Enter Redirect Url "
                           [(ngModel)]="redirectUrls"
                           pattern="^(https?|chrome):\/\/[^\s$.?#].[^\s]*$" #uris=ngModel
                           required />
                  </div>
                  <p *ngIf="!uris.valid" class="msgred">Redirect Url must in format https://fqdn/resource</p>
                </div>
              </div>

              <div class="file-field">

                <div *ngIf="imgAreaVisible" class="z-depth-1-half mb-4">

                  <img class=" logo" [src]="convertImage" alt="" />
                </div>

                <!-- <div class="d-flex justify-content-center"> -->
                <div class="btn btn-mdb-color btn-rounded float-left leftpadding">
                  <span>Choose Logo</span>
                  <input type="file" (change)="onFileSelect($event)" accept="image/png,image/jpg,image/jpeg" />
                </div>
                <p class="msgred">Image should be type of image only like .jpg/png</p>

                <!-- </div> -->
              </div>
              <br>
              <br>
              <br>

              <!-- <div class="form-group">
                <label for="appName" class="cols-sm-2 control-label required"
                  >Privacy Policy</label>
                <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"
                      ></span>
                    <input
                      type="text"
                      class="form-control"
                       name = "Privacy Policy"
                      placeholder="Enter Privacy Policy Url"
                      ngModel
                      required />
                  </div>
                </div>
              </div> -->
              <!-- <div class="form-group"> -->
              <!-- <label for="username" class="cols-sm-2 control-label">Terms and Conditions</label> -->
              <!-- <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"></span>
                    <textarea readonly class="form-control textarea" name="policy" id="policy" placeholder="There will be Privacy Policies.There will be Privacy Policies.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

                    If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

                    example using twig for php framework symfony :"></textarea>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-check">
                    <input [(ngModel)]="checkedPolicy" #policy_check="ngModel"
                      (change)="checkboxPolicyClicked(checkedPolicy)" class="form-check-input" type="checkbox"
                      id="gridCheck" name="PrivacyPolicy" required />
                    <label class="form-check-label required" for="gridCheck">
                      Privacy Policy
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group"> -->
              <!-- <label for="username" class="cols-sm-2 control-label">Terms and Conditions</label> -->
              <!-- <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"></span>
                    <textarea readonly class="form-control textarea" name="terms" id="terms" placeholder="There will be Terms and Conditions.There will be Terms and Conditions.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

                    If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

                    example using twig for php framework symfony :"></textarea>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-check">
                    <input [(ngModel)]="checkedTerms" #terms_check="ngModel" (change)="checkboxTermsClicked(checkedTerms)"
                      class="form-check-input" type="checkbox" id="gridCheck" name="TOSAttestation" ngModel required />
                    <label class="form-check-label required" for="gridCheck">
                      Terms and Conditions
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group"> -->
              <!-- <label for="username" class="cols-sm-2 control-label">Code of Conduct</label> -->
              <!-- <div class="cols-sm-10">
                  <div class="input-group">
                    <span class="input-group-addon"></span>
                    <textarea readonly class="form-control textarea" name="code-of-conduct" id="code-of-conduct"
                      placeholder="There will be code-of-conduct.There will be code-of-conduct.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

                    If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

                    example using twig for php framework symfony :"></textarea>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-check">
                    <input [(ngModel)]="checkedCodeConduct" #cod_check="ngModel"
                      (change)="checkboxCodeConductClicked(checkedCodeConduct)" class="form-check-input" type="checkbox"
                      id="gridCheck" name="CodeOfConductAttestation" ngModel required />
                    <label class="form-check-label required" for="gridCheck">
                      Code of Conduct
                    </label>
                  </div>
                </div>
              </div> -->

              <div class="form-group">
                <button type="submit" [disabled]="!f.valid" class="btn btn-lg btn-primary register">
                  Register
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <app-footer></app-footer>
</div>
